











import { Component, Vue, Prop } from 'vue-property-decorator';
import { UpdateJobDto } from '@/shared/dtos/agents-admin';
import GenericTable from '@/components/agents-admin/common/GenericTable.vue';

@Component({
    components: { GenericTable }
})
export default class UpdateJobsTab extends Vue {
    @Prop() public updateJobs: UpdateJobDto[] = [];
    @Prop() public loading: boolean = false;

    public headers = [
        { text: 'ID del Job', value: 'update_job_id', sortable: true },
        { text: 'Agente', value: 'agent_id', sortable: true },
        { text: 'De Versión', value: 'from_version', sortable: true },
        { text: 'A Versión', value: 'to_version', sortable: true },
        { text: 'Estado', value: 'status', sortable: true },
        { text: 'Progreso %', value: 'progress_percent', sortable: true }
    ];
}
